import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"

import FieldMultiselect_PopoverSearch from "../../../multiselect/components/popover/popover-search"
import FieldMultiselect_PopoverOptionsSelector from "../../../multiselect/components/popover/popover-options-selector"
import FieldMultiselect_PopoverMenu from "../../../multiselect/components/popover/popover-menu"
import FieldAssignees_SelectedOption from "./selected-option"
import PopoverMenuHeader from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-header"
import FieldAssignees from "../../assignees";

const SEARCH_SHOW_THRESHOLD = 6; // min options to show search input

const debug = false
// const debug = 'FieldAssignees_PopoverMenu'

export default class FieldAssignees_PopoverMenu extends FieldMultiselect_PopoverMenu {

    onRemove = (option:Option) => {
        const hidePopover = option.value === gd.user.id
        this.props.parent.onOptionClick(option, hidePopover)
    }

    render() {
        const isManager = gd.ac.check.company.isManager()
        const options = this.props.field.getOptions()

        const PopoverMenuMore = _.get(this.props.field.components, 'PopoverMenuMore', false)

        const selectedOptionsIds = this.props.parent.state.currentOptions ? this.props.parent.state.currentOptions : []
        const selectedOptions = _(options)
            .filter(option=>selectedOptionsIds.includes(option.value))
            .orderBy(option=>option.label, 'asc')
            .value()
        const unselectedOptionsLength = options!.length - selectedOptions.length
        const showAddUser = unselectedOptionsLength > 0

        const field                 = this.props.field as FieldAssignees

        const showSelected          = !_.isEmpty(selectedOptions)
        const selectionIsMandatory  = field.selectionIsMandatory
        const isRemoveForbidden     = selectionIsMandatory && selectedOptions.length <= 1

        debug && console.log(debug, 'render', selectedOptions)

        const classes = Classes("ui5-popover-menu", this.props.field.classes.PopoverMenu, {
            'p-t-0'     : showSelected,
            'with-help' : isManager && PopoverMenuMore
        })

        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover className          = "w-250"
                     position           = {popoverPosition}
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                {showSelected &&
                    <div className="ui5-popover-menu p-b-0">
                        <VScroll minDragHeight={20} containerClass="max-h-150" scrollVisibility="auto">
                            {_.map(selectedOptions, option => {
                                const forbidRemove = isRemoveForbidden || (field.selfUserIsMandatory && gd.user.id === option.value)
                                return (
                                    <FieldAssignees_SelectedOption key      = {option.value}
                                                                   option   = {option}
                                                                   onRemove = {forbidRemove ? null : this.onRemove}/>
                                )
                            })}
                        </VScroll>
                        {showAddUser && <div className="separator"/>}
                    </div>}

                <div className={classes}>
                    {showAddUser &&
                        <>
                            <PopoverMenuHeader title="Add user"/>

                            <FieldMultiselect_PopoverSearch className       = "p-t-0"
                                                            placeholder     = "Search by user name"
                                                            searchable      = {this.props.field.isSearchable && unselectedOptionsLength > SEARCH_SHOW_THRESHOLD}
                                                            searchString    = {this.state.searchString}
                                                            onHidePopover   = {this.props.parent.hidePopover}
                                                            onSearchChange  = {this.onSearchChange}/>

                            <VScroll minDragHeight={20} containerClass={this.props.field.classes.PopoverMenuScrollContainer} scrollVisibility="auto">
                                <FieldMultiselect_PopoverOptionsSelector ref={(r:any)=>this.optionsSelector = r} {...this.props} searchString={this.state.searchString} onUpdateScroll={this.updateScroll}/>
                            </VScroll>
                        </>}


                    {isManager && PopoverMenuMore && <PopoverMenuMore {...this.props}/>}
                </div>
            </Popover>
        )
    }
}